import React, { useState, useEffect } from "react";
import axios from "axios";
import { Col, Row, Label } from "reactstrap";
import Header from "../../../components/Header";
import { UserConsumer } from "../../../UserContext";
import "./SpResourceLeavesInfo.scss";
import { useHistory, useLocation, useParams } from "react-router-dom";
import SpResourceLeavesInfo from "./SpResourceLeavesInfo";
import AdminResourceLeavesInfo from "./AdminResourceLeavesInfo";
import { ResourceLeavesInfo_API } from "./ResourceLeavesInfo_API";
import { ExcelBtnClassName, ExcelBtnTitle } from "../../ticketModule/variables/ListingVariables";
import ButtonLoader from "../../../components/ButtonLoader";

function ResourceLeavesInfo() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(true);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const { state } = useLocation();
	const employeeLeaveListingRedirection = state
		? state.employeeLeaveListingRedirection
		: false;
	const [resLeavesInfoData, setResLeavesInfoData] = useState({
		empID: 0,
		employeeName: "Employee Name here...",
		employeeCode: "0",
		employeeDepartment: "Employee Department here...",
		sickLeave: 0,
		compansationLeave: 0,
		annualLeave: 0,
		withoutPayLeave: 0,
		maternityLeave: 0,
		otherLeave: 0,
	});
	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			//get resource info
			axios
				.get(
					`${ResourceLeavesInfo_API.GetResourceLeavesInfoById}/${id}`,
					{
						headers: header,
					}
				)
				.then(({ status, data }) => {
					if (status === 200) {
						setResLeavesInfoData(data);
					}
				});
		}
	}, []);

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							{id ? (
								<>
									<Header
										title="Leave Balance"
										headerBorder="false"
										navigateBack={() =>
											employeeLeaveListingRedirection
												? history.push(
														"/EmployeeLeavesListing"
												  )
												: history.push("/ViewEmployees")
										}
									/>
									{employeeLeaveListingRedirection ? null : (
										<div className="errorMessageContainer errorMessage pl-3">
											{
												"This leave balance is represented of the current year. To view the previous year data you can view the leave balance log"
											}
										</div>
									)}
								</>
							) : (
								<Header
									title="Employees Leaves Info"
									headerBorder="false"
								/>
							)}
							{id ? (
								<>
									<div className="formInfoContainer my-3">
										<div className="formInfoContainerHeader">
											<Label sm={12}>
												Personal Information
											</Label>
										</div>
										<Row className="py-2 px-4">
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Employee Name</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.employeeName
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Employee Code</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.employeeCode
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Department</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.employeeDepartment
													}
												</p>
											</Col>
										</Row>
									</div>
									<div className="formInfoContainer">
										<div className="formInfoContainerHeader">
											<Label sm={12}>Leave Balance</Label>
										</div>
										<Row className="py-2 px-4">
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Sick</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.sickLeave
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Compensation</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.compansationLeave
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>withoutPay</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.withoutPayLeave
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Others</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.otherLeave
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Annual</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.annualLeave
													}
												</p>
											</Col>
											<Col md={12} lg={3}>
												<div className="formDetailHeader">
													<div>Maternity</div>
												</div>
											</Col>
											<Col md={12} lg={3}>
												<p className="formValueContainer">
													{
														resLeavesInfoData.maternityLeave
													}
												</p>
											</Col>
										</Row>
									</div>
								</>
							) : (
								<>
									{userDetails.empRole.includes("3") ? (
										<AdminResourceLeavesInfo />
									) : (
										<SpResourceLeavesInfo />
									)}{" "}
								</>
							)}
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default ResourceLeavesInfo;
